import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=a58e0520&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=a58e0520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e0520",
  null
  
)

export default component.exports